import React from "react";
import { useState } from "react";
import { useMemo } from "react";
import PageHeader from "../components/PageHeader";
import ReportTable from "../components/ReportTable";
import Loader from "../components/Loader";
import Pagination from "../components/Pagination";
import DateRangeFilter from "../components/DateRangeFilter";
import SkSelect from "../components/SkSelect";
import SkDatePicker from "../components/SkDatePicker";
import "../assets/css/manualentry.css"
import "../assets/css/shiftgroup.css"
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useCallback } from "react";
import {
    addManualEntry, getManualEntryList, getDeleteMessageManual,
    deleteManualEntry, updateManualEntry, getUpdateManualEntry, getShiftTiming
}
    from "../redux/ManualEntry/manualEntryAction";
import { selectManualEntryList, /*selectManualEntryLoading*/ }
    from "../redux/ManualEntry/manualEntrySelectors";
import { number } from "framer-motion";
import { shiftList } from "../redux/shiftgroup/ShiftGroupActions";
import { selectShiftData } from "../redux/shiftgroup/ShiftGroupSelector";
import { attendanceStatusList } from "../redux/status/StatusActions";
import { selectAttendanceStatus } from "../redux/status/StatusSelector";
import moment from "moment-timezone";
import { formatWithTimeZone, calculateWorkingTime, formatTime24, normalizeTotalTimeFilter } from "../utils/common";
const ManualEntry = () => {
    const attendanceStatus = useSelector(selectAttendanceStatus);
    const statusFilterOptions = [
        { label: "All", value: "" },
        ...attendanceStatus.filter((status) => status.Status === true || status.Status === 1)
            .map((item) => ({
                label: (item.AttendanceStatus).toUpperCase(),
                value: item.ShortName,
            })),
    ];
    const columns = useMemo(() => [
        { key: "action", label: "Action" },
        {
            key: "approvalStatus",
            label: "Approval Status",
            filterType: "select",
            filterOptions: [
                { label: "All", value: "All" },
                { label: "Pending", value: "Pending" },
                { label: "Approved", value: "Approved" },
                { label: "Rejected", value: "Rejected" },
            ]
        },
        { key: "employeeName", label: "Employee Name", filterType: "text", },
        { key: "attendanceDate", label: "Attendance Date", filterType: "date", },
        { key: "clockIn", label: "Clock In", filterType: "time", },
        { key: "clockOut", label: "Clock Out", filterType: "time", },
        { key: "totalTime", label: "Total Time", filterType: "text", },
        {
            key: "status",
            label: "Status",
            filterType: "select",
            filterOptions: statusFilterOptions,
        },
        { key: "reason", label: "Reason", filterType: "text", },
    ])
    const emptyForm = {
        manualCode: "",
        employeeName: "",
        shiftCode: "",
        attendanceDate: "",
        clockIn: "",
        clockOut: "",
        totalMinutes: "",
        totalHours: "",
        motHours: "",
        AttendanceStatus: "",
        reason: "",
    };

    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState(emptyForm);
    const [baseClockIn, setBaseClockIn] = useState("");
    const [baseClockOut, setBaseClockOut] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        ApprovalStatus: "All",
        EmployeeName: "",
        AttendanceDate: "",
        ClockIn: "",
        ClockOut: "",
        TotalTime: "",
        MotHours: "",
        Status: "",
        Reason: ""
    });
    const [debouncedFilters, setDebouncedFilters] = useState(filters);
    const [highlightFields, setHighlightFields] = useState([]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedFilters(filters);
        }, 500);

        return () => clearTimeout(timer);
    }, [filters]);

    const dispatch = useDispatch();
    const manualEntryList = useSelector(selectManualEntryList);
    const manualMeta = useSelector(state => state.manualEntry.manualMeta);
    const [selectedManualCode, setSelectedManualCode] = useState(null);
    const shiftData = useSelector(selectShiftData);

    useEffect(() => {
        dispatch(
            shiftList({
                PageNumber: currentPage,
                pageSize: pageSize,
            })
        );

        dispatch(attendanceStatusList());
    }, [dispatch]);

    const data = manualEntryList.map((item, index) => ({
        id: item.ManualCode,
        manualCode: item.ManualCode,
        approvalStatus: (
            <button
                className={
                    item.Approval
                        ? "status-btn approve-status"
                        : item.Reject
                            ? "status-btn reject-status"
                            : "status-btn pending-status"
                }
            >
                {item.Approval
                    ? "Approved"
                    : item.Reject
                        ? "Rejected"
                        : "Pending"}
            </button>
        ),
        sno: index + 1,
        employeeName: item.UserName?.toUpperCase() || "",
        AttendanceStatus: item.attendanceStatus,
        attendanceDate: formatWithTimeZone(item.AttendanceDate, "DD-MM-yy"),
        clockIn: formatWithTimeZone(item.ClockIn, "hh:mm:ss A"),
        clockOut: formatWithTimeZone(item.ClockOut, "hh:mm:ss A"),
        totalMinutes: item.TotalMinutes,
        totalHours: formatWithTimeZone(item.TotalHours, "HH:mm"),
        motHours: item.MOTHours ? formatWithTimeZone(item.MOTHours, "HH:mm") : "-",
        status: item.StatusCode,
        reason: item.Reason,
        totalTime: item.TotalHours
            ? `${item.TotalHours.substring(0, 2)}h:${item.TotalHours.substring(3, 5)}m` : "-",
    }));

    const deleteMessage = useSelector(
        state => state.manualEntry.deleteMessage
    );

    const isBlank = (v) =>
        v === undefined || v === null || String(v).trim() === "";

    const getManualEntryErrors = (data) => {
        const errors = {};

        if (isBlank(data.employeeName)) {
            errors.employeeName = "Employee Name is required.";
        } else if (!/^[A-Za-z ]+$/.test(data.employeeName)) {
            errors.employeeName = "Only alphabets allowed.";
        }
        if (isBlank(data.shiftCode)) {
            errors.shiftCode = "Shift Code is required."
        }
        if (isBlank(data.attendanceDate)) {
            errors.attendanceDate = "Attendance Date is required.";
        }
        else {
            const selectedDate = new Date(data.attendanceDate);
            const today = new Date();

            selectedDate.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);
            if (selectedDate > today) {
                errors.attendanceDate = "Future dates are not allowed.";
            }
        }

        if (isBlank(data.clockIn)) {
            errors.clockIn = "Clock In is required.";
        }

        if (isBlank(data.clockOut)) {
            errors.clockOut = "Clock Out is required.";
        }

        if (isBlank(data.totalMinutes)) {
            errors.totalMinutes = "Total Minutes is required.";
        } else {
            const entered = Number(data.totalMinutes);
            if (entered < 0) {
                errors.totalMinutes = "Total minutes cannot be negative";
            } else if (!isBlank(data.clockIn) && !isBlank(data.clockOut)) {
                const diff = calculateWorkingTime(data.clockIn, data.clockOut,).totalMinutes;
                if (diff > 0 && entered !== diff) {
                    errors.totalMinutes = `Invalid total minutes. Expected ${diff}.`;
                }
            }
        }

        if (isBlank(data.totalHours)) {
            errors.totalHours = "Total Hours is required.";
        } else {
            if (!/^\d{2}:\d{2}$/.test(data.totalHours)) {
                errors.totalHours = "Use HH:MM format.";
            } else if (!isBlank(data.clockIn) && !isBlank(data.clockOut)) {
                const diff = calculateWorkingTime(data.clockIn, data.clockOut,).totalMinutes;
                if (diff > 0) {
                    const hours = Math.floor(diff / 60);
                    const mins = diff % 60;

                    const expected = calculateWorkingTime(data.clockIn, data.clockOut,).totalHours; if (data.totalHours !== expected) {
                        errors.totalHours = `Invalid total hours. Expected ${expected}.`;
                    }
                }
            }
        }
        if (!isBlank(data.motHours)) {
            if (!/^\d{2}:\d{2}$/.test(data.motHours)) {
                errors.motHours = "Enter HH:MM format.";
            } else {
                const hours = Number(data.motHours.substring(0, 2));
                const minutes = Number(data.motHours.substring(3, 5));

                if (hours > 23 || minutes > 59) {
                    errors.motHours = "Invalid time.";
                }
            }
        }
        if (isBlank(data.reason)) {
            errors.reason = "Reason is required.";
        }
        else if (!/^[A-Za-z0-9]/.test(data.reason.trim())) {
            errors.reason = "Reason must start with an alphabet or number.";
        }
        else if (data.reason.length > 250) {
            errors.reason = "Reason cannot exceed 250 characters.";
        }
        return errors;
    };
    const TOUCH_ALL = {
        employeeName: true,
        shiftCode: true,
        attendanceDate: true,
        clockIn: true,
        clockOut: true,
        totalMinutes: true,
        totalHours: true,
        motHours: true,
        attendanceStatus: true,
        reason: true,
    };

    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});

    const validateForm = (form) => {
        const newErrors = getManualEntryErrors(form);
        setErrors(newErrors);
        setTouched(TOUCH_ALL);
        return Object.keys(newErrors).length === 0;
    };

    const runValidation = (nextForm, field) => {
        setErrors(getManualEntryErrors(nextForm));
        setTouched((prev) => ({
            ...prev,
            [field]: true,
        }));
    };

    const resetValidation = () => {
        setErrors({});
        setTouched({});
    };

    const inputClass = (field) =>
        touched[field] && errors[field]
            ? "input-error"
            : "";
    const fieldError = (field) =>
        touched[field] && errors[field] ? (
            <p className="error-text">{errors[field]}</p>
        ) : null;
    const addMinutes = (time, minutes) => {
        let t = moment(time, "HH:mm:ss");
        t.add(minutes, "minutes");
        return t.format("HH:mm:ss");
    };

    const calculateTime = (clockIn, clockOut) => {
        let start = moment(clockIn, "HH:mm:ss");
        let end = moment(clockOut, "HH:mm:ss");
        if (end.isSameOrBefore(start))
            end.add(1, "day");
        const totalMinutes = end.diff(start, "minutes");
        return {
            totalMinutes,
            totalHours: moment
                .utc(totalMinutes * 60000)
                .format("HH:mm"),
        };
    };
    const handleClockInChange = (value) => {
        const result = calculateWorkingTime(
            value,
            formData.clockOut,

        );
        const next = {
            ...formData,
            clockIn: value,
            totalMinutes: result.totalMinutes,
            totalHours: result.totalHours
        };
        setFormData(next);
        runValidation(next, "clockIn");
    };

    const handleClockOutChange = (value) => {
        const result = calculateWorkingTime(
            formData.clockIn,
            value,
        );
        const next = {
            ...formData,
            clockOut: value,
            totalMinutes: result.totalMinutes,
            totalHours: result.totalHours
        };
        setFormData(next);
        runValidation(next, "clockOut");
    };

    const handleChange = (field, value) => {
        let next = {
            ...formData,
            [field]: value,
        };
        if (field === "motHours") {
            const motMinutes = value
                ? Number(value.split(":")[0]) * 60 +
                Number(value.split(":")[1])
                : 0;
            let startClockOut =
                next.attendanceStatus === "HD"
                    ? addMinutes(
                        baseClockIn, Math.floor(
                            calculateTime(baseClockIn, baseClockOut).totalMinutes / 2
                        )) : baseClockOut;
            if (next.attendanceStatus === "HD") {
                const shift = calculateTime(baseClockIn, baseClockOut);
                startClockOut = addMinutes(
                    baseClockIn,
                    Math.floor(shift.totalMinutes / 2)
                );
            }
            next.clockOut = addMinutes(startClockOut, motMinutes);
            highlightUpdatedFields([
                "clockOut",
                "totalMinutes",
                "totalHours",
            ]);
        }
        if (field === "attendanceStatus") {

            if (value === "HD") {

                const shift = calculateTime(
                    baseClockIn,
                    baseClockOut
                );

                let halfClockOut = addMinutes(
                    baseClockIn,
                    Math.floor(shift.totalMinutes / 2)
                );

                if (next.motHours) {

                    const motMinutes =
                        Number(next.motHours.split(":")[0]) * 60 +
                        Number(next.motHours.split(":")[1]);

                    halfClockOut = addMinutes(
                        halfClockOut,
                        motMinutes
                    );
                }

                next.clockOut = halfClockOut;
            }

            else {

                next.clockOut = baseClockOut;

                if (next.motHours) {

                    const motMinutes =
                        Number(next.motHours.split(":")[0]) * 60 +
                        Number(next.motHours.split(":")[1]);

                    next.clockOut = addMinutes(
                        next.clockOut,
                        motMinutes
                    );
                }

            }

            highlightUpdatedFields([
                "clockOut",
                "totalMinutes",
                "totalHours"
            ]);
        }
        if (
            field === "clockIn" ||
            field === "clockOut" ||
            field === "motHours" ||
            field === "attendanceStatus"
        ) {
            const result = calculateTime(
                next.clockIn,
                next.clockOut
            );

            next.totalMinutes = result.totalMinutes;
            next.totalHours = result.totalHours;
        }
        setFormData(next);
        runValidation(next, field);
    };

    const handleShiftChange = (shiftCode) => {
        dispatch(getShiftTiming(shiftCode)).then((res) => {


            if (res.meta.requestStatus === "fulfilled") {
                const shift = res.payload.data.data;
                setBaseClockIn(`${shift.InTime}:00`);
                setBaseClockOut(`${shift.OutTime}:00`);

                const next = {
                    ...formData,
                    shiftCode,
                    clockIn: `${shift.InTime}:00`,
                    clockOut: `${shift.OutTime}:00`,
                    totalMinutes: shift.TotalMinutes,
                    totalHours: shift.TotalHours,
                };
                setFormData(next);
                highlightUpdatedFields([
                    "clockIn",
                    "clockOut",
                    "totalMinutes",
                    "totalHours",
                ]);
                runValidation(next, "shiftCode");
            }
        });
    };
    const handleSave = () => {
        const user = JSON.parse(localStorage.getItem("user"))
        if (!validateForm(formData)) return;
        setLoading(true);
        const clockOutDate = moment(formData.attendanceDate);

        if (formData.clockOut < formData.clockIn) {
            clockOutDate.add(1, "day");
        }
        dispatch(addManualEntry({
            UserCode: user.userId,
            ShiftCode: formData.shiftCode,
            AttendanceDate: formData.attendanceDate,
            ClockIn: `${formData.attendanceDate} ${formData.clockIn}`,
            ClockOut: `${clockOutDate.format("YYYY-MM-DD")} ${formData.clockOut}`,
            TotalMinutes: Number(formData.totalMinutes),
            TotalHours: `${formData.totalHours}:00`,
            AttendanceStatus: formData.attendanceStatus,
            Reason: formData.reason
        }))
            .then((res) => {

                if (res.meta.requestStatus === "fulfilled") {
                    setShowModal(false);
                    setFormData(emptyForm);
                    setSelectedManualCode(null)
                    dispatch(getManualEntryList(buildParams()));
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const handleEdit = (row) => {
        setLoading(true);
        const user = JSON.parse(localStorage.getItem("user"));
        dispatch(
            getUpdateManualEntry({
                UserCode: user.userId,
                manualCode: row.manualCode,

            })
        ).then((res) => {
            if (res.meta.requestStatus === "fulfilled") {
                const data = res.payload.data.data;
                setBaseClockIn(
                    data.ClockIn
                        ? moment.utc(data.ClockIn).format("HH:mm:ss")
                        : ""
                );
                setBaseClockOut(
                    data.ClockOut
                        ? moment.utc(data.ClockOut).format("HH:mm:ss")
                        : ""
                );
                setFormData({
                    manualCode: data.ManualCode,
                    employeeName: data.UserName || "",
                    shiftCode: Number(data.ShiftCode),
                    attendanceDate: data.AttendanceDate
                        ? moment.utc(data.AttendanceDate).format("YYYY-MM-DD")
                        : "",
                    clockIn: data.ClockIn
                        ? moment.utc(data.ClockIn).format("HH:mm:ss")
                        : "",
                    clockOut: data.ClockOut
                        ? moment.utc(data.ClockOut).format("HH:mm:ss")
                        : "",
                    totalMinutes: data.TotalMinutes,
                    totalHours: data.TotalHours
                        ? formatWithTimeZone(data.TotalHours, "HH:mm")
                        : "",
                    motHours: data.MOTHours
                        ? formatWithTimeZone(data.MOTHours, "HH:mm")
                        : "",
                    attendanceStatus: data.StatusCode ? data.StatusCode.trim() : "",
                    reason: data.Reason || "",
                });
                setIsEdit(true);
                setShowModal(true);
                resetValidation();
                resetValidation();
            }
        })
            .finally(() => {
                setLoading(false);
            });
    };
    const handleUpdate = () => {
        const valid = validateForm(formData);
        if (!valid) return;
        const user = JSON.parse(localStorage.getItem("user"));
        setLoading(true);
        const clockOutDate = moment(formData.attendanceDate);
        if (formData.clockOut < formData.clockIn) {
            clockOutDate.add(1, "day");
        }
        dispatch(updateManualEntry({
            manualCode: formData.manualCode,
            UserCode: user.userId,
            shiftCode: Number(formData.shiftCode),
            attendanceDate: formData.attendanceDate,
            clockIn: `${formData.attendanceDate} ${formData.clockIn}`,
            clockOut: `${clockOutDate.format("YYYY-MM-DD")} ${formData.clockOut}`,
            totalMinutes: Number(formData.totalMinutes),
            totalHours: `${formData.totalHours}:00`,
            attendanceStatus: formData.attendanceStatus,
            reason: formData.reason,
            allowApprovedEdit: 1
        })
        ).then((res) => {
            if (res.meta.requestStatus === "fulfilled") {
                setShowModal(false);
                setFormData(emptyForm);
                setIsEdit(false);
                dispatch(getManualEntryList(buildParams()));
            }
        })
            .finally(() => {
                setLoading(false);
            });
    };
    const handleDelete = async (manualCode) => {
        setSelectedManualCode(manualCode);
        const user = JSON.parse(localStorage.getItem("user"));
        const result = await dispatch(
            getDeleteMessageManual({ manualCode, UserCode: user.userId, })
        );
        if (getDeleteMessageManual.fulfilled.match(result)) {
            setShowDeleteModal(true);
        }
    };
    const handleConfirmDelete = () => {
        setLoading(true);
        const user = JSON.parse(localStorage.getItem("user"));
        dispatch(
            deleteManualEntry({ manualCode: selectedManualCode, UserCode: user.userId, })
        ).then((res) => {
            if (res.meta.requestStatus === "fulfilled") {
                setShowDeleteModal(false);
                setSelectedManualCode(null);
                dispatch(getManualEntryList(buildParams()));
            }
        })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleHeaderFilterChange = useCallback((cf) => {
        console.log("cf.totalTime =", cf.totalTime);
        console.log("typeof =", typeof cf.totalTime);
        const totalTime = cf.totalTime?.value || "";
        const newFilters = {
            ApprovalStatus: cf.approvalStatus?.value || "All",
            EmployeeName: cf.UserName?.value || "",
            AttendanceDate: cf.attendanceDate?.start || "",
            ClockIn: cf.clockIn?.value || cf.clockIn || "",
            ClockOut: cf.clockOut?.value || cf.clockOut || "",
            TotalTime:
                typeof cf.totalTime === "object"
                    ? cf.totalTime.value || ""
                    : cf.totalTime || "",
            MotHours: cf.motHours?.value || "",
            Status: cf.status?.value || "",
            Reason: cf.reason?.value || "",
        };
        setFilters(prev => {
            if (JSON.stringify(prev) === JSON.stringify(newFilters)) {
                return prev;
            }
            return newFilters;
        });
        setCurrentPage(1);
    }, []);

    const buildParams = useCallback(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        let statusPayload = {};
        switch (debouncedFilters.ApprovalStatus) {
            case "Approved":
                statusPayload = {
                    Approval: 1,
                };
                break;
            case "Rejected":
                statusPayload = {
                    Reject: 1,
                };
                break;
            case "All":
                statusPayload = {};
                break;
            default:
                statusPayload = {
                    Pending: 1,
                };
        }
        const params = {
            UserCode: user.userId,
            PageNumber: currentPage,
            PageSize: pageSize,
            ...statusPayload,
        };
        if (debouncedFilters.EmployeeName)
            params.EmployeeName = debouncedFilters.EmployeeName;
        if (debouncedFilters.AttendanceDate) {
            params.AttendanceDate = moment(debouncedFilters.AttendanceDate).format("YYYY-MM-DD");
        }
        if (debouncedFilters.ClockIn) {
            const value = formatTime24(debouncedFilters.ClockIn);
            if (value) {
                params.ClockIn = value;
            }
        }
        if (debouncedFilters.ClockOut) {
            const value = formatTime24(debouncedFilters.ClockOut);
            if (value) {
                params.ClockOut = value;
            }
        }
        if (debouncedFilters.TotalTime) {
            console.log("Input =", debouncedFilters.TotalTime);
            const value = normalizeTotalTimeFilter(debouncedFilters.TotalTime);
            console.log("Normalized =", value);
            if (value) {
                params.TotalHours = value;
            }
        }
        if (debouncedFilters.Status)
            params.Status = debouncedFilters.Status;
        if (debouncedFilters.Reason)
            params.Reason = debouncedFilters.Reason;
        return params;
    }, [currentPage, pageSize, debouncedFilters]);
    useEffect(() => {
        const load = async () => {
            setLoading(true);
            await dispatch(getManualEntryList(buildParams()));
            setLoading(false);
        };
        load();
    }, [dispatch, buildParams]);
    const handleCloseModal = () => {
        setShowModal(false);
        setFormData(emptyForm);
        resetValidation();
    }
    const highlightUpdatedFields = (fields) => {
        setHighlightFields(fields);
        clearTimeout(window.highlightTimer);
        window.highlightTimer = setTimeout(() => {
            setHighlightFields([]);
        }, 2000);
    };
    return (
        <>
            {loading && <Loader isLoading={true} />}
            <div className="manualentry-page " >

                <PageHeader
                    icon={<i className="bi bi-person-check w-15 h-15"></i>}
                    title="Manual Entry"
                    subtitle="Manual Attendance Entry for Employees"
                    actions={
                        <>
                            <button className="add-entry-btn"
                                onClick={() => {
                                    const user = JSON.parse(localStorage.getItem("user"));
                                    setFormData({
                                        ...emptyForm,
                                        employeeName: user.userName,
                                    });
                                    setIsEdit(false);
                                    resetValidation();
                                    setShowModal(true);
                                }}>
                                + New
                            </button>
                        </>
                    }
                />
                <div className="manual-data">
                    <ReportTable
                        columns={columns}
                        data={data}
                        serverSide={true}
                        stickyColumns={["action"]}
                        onHeaderFilterChange={handleHeaderFilterChange}
                        renderActions={(row) => (
                            <div className="manual-action-buttons">
                                <button
                                    className="action-btn edit-btn"
                                    onClick={() => handleEdit(row)}
                                >
                                    <i className="bi bi-pencil-square"></i>
                                </button>
                                <button
                                    className="action-btn delete-btn"
                                    onClick={() => handleDelete(row.manualCode)}
                                >
                                    <i className="bi bi-trash-fill"></i>
                                </button>
                            </div>
                        )}
                    />
                    <Pagination
                        currentPage={currentPage}
                        totalCount={manualMeta?.totalRecords || 0}
                        pageSize={pageSize}
                        onPageChange={setCurrentPage}
                        onPageSizeChange={(size) => { setPageSize(size); setCurrentPage(1); }}
                    />
                    {showModal && (
                        <div className="se-overlay">
                            <div className="se-modal manual-modal">
                                <div className="se-modal__header">
                                    <div>
                                        <h3>
                                            {isEdit ? "Edit Manual Entry" : "Add Manual Entry"}
                                        </h3>
                                        <p className="se-modal__subtitle">
                                            Create or update employee attendance manually
                                        </p>
                                    </div>
                                    <button
                                        className="se-close"
                                        onClick={handleCloseModal}
                                    >
                                        <i className="bi bi-x-lg"></i>
                                    </button>
                                </div>
                                <div className="se-modal__body">
                                    <section className="se-section">
                                        <h4 className="se-section__title">
                                            Employee Details
                                        </h4>

                                        <div className="se-grid">
                                            <div className="se-field">
                                                <label>Employee Name</label>
                                                <input
                                                    className={`se-input ${inputClass("employeeName")}`}
                                                    type="text"
                                                    placeholder="Enter Employee Name"
                                                    disabled
                                                    value={formData.employeeName}
                                                    onChange={(e) => handleChange(
                                                        "employeeName",
                                                        e.target.value
                                                    )}
                                                />
                                                {fieldError("employeeName")}
                                            </div>
                                            <div className="se-field">
                                                <label>Shift Name</label>
                                                <SkSelect
                                                    size="md"
                                                    width="100%"
                                                    placeholder="Select Shift"
                                                    searchable={true}
                                                    value={formData.shiftCode}
                                                    options={shiftData
                                                        .filter((shift) => shift.Status === true || shift.Status === 1)
                                                        .map((shift) => ({
                                                            value: shift.ShiftCode,
                                                            label: (shift.ShiftName).toUpperCase(),
                                                        }))}
                                                    onChange={handleShiftChange}
                                                />
                                                {fieldError("shiftCode")}
                                            </div>
                                            <div className="se-field">
                                                <label>Attendance Date</label>
                                                <SkDatePicker
                                                    size="md"
                                                    block
                                                    invalid={!!(touched.attendanceDate && errors.attendanceDate)}
                                                    value={formData.attendanceDate}
                                                    onChange={(value) =>
                                                        handleChange("attendanceDate", value)
                                                    }
                                                />
                                                {fieldError("attendanceDate")}
                                            </div>
                                        </div>
                                    </section>
                                    <section className="se-section">
                                        <h4 className="se-section__title">
                                            Attendance Details
                                        </h4>
                                        <div className="se-grid">
                                            <div className="se-field">
                                                <label>Clock In</label>
                                                <input
                                                    className={`se-input ${inputClass("clockIn")}
                                                    ${highlightFields.includes("clockIn") ?
                                                            "field-highlight" : ""}`}
                                                    type="time"
                                                    step="1"
                                                    value={formData.clockIn || ""}
                                                    disabled
                                                    onChange={(e) => handleClockInChange(e.target.value)}
                                                />
                                                {fieldError("clockIn")}
                                            </div>
                                            <div className="se-field">
                                                <label>Clock Out</label>
                                                <input
                                                    className={`se-input ${inputClass("clockOut")}
                                                    ${highlightFields.includes("clockOut") ?
                                                            "field-highlight" : ""}`}
                                                    type="time"
                                                    step="1"
                                                    value={formData.clockOut || ""}
                                                    disabled
                                                    onChange={(e) => handleClockOutChange(e.target.value)}
                                                />
                                                {fieldError("clockOut")}
                                            </div>
                                        </div>
                                    </section>
                                    <div className="se-grid">
                                        <div className="se-field">
                                            <label>Total Minutes</label>
                                            <input
                                                className={`se-input ${inputClass("totalMinutes")}
                                                ${highlightFields.includes("totalMinutes") ?
                                                        "field-highlight" : ""}`}
                                                type="text"
                                                min="0"
                                                value={formData.totalMinutes}
                                                disabled
                                                onChange={(e) => {
                                                    handleChange(
                                                        "totalMinutes",
                                                        e.target.value
                                                    )
                                                }}
                                            />
                                            {fieldError("totalMinutes")}
                                        </div>
                                        <div className="se-field">
                                            <label>Total Hours</label>
                                            <input
                                                className={`se-input ${inputClass("totalHours")}
                                                ${highlightFields.includes("totalHours") ?
                                                        "field-highlight" : ""}`}
                                                type="text"
                                                placeholder="HH:MM"
                                                value={formData.totalHours}
                                                disabled
                                                onChange={(e) => {
                                                    handleChange(
                                                        "totalHours",
                                                        e.target.value
                                                    )
                                                }}
                                            />
                                            {fieldError("totalHours")}
                                        </div>
                                    </div>
                                    <div className="se-grid">
                                        <div className="se-field">
                                            <label>Status</label>
                                            <SkSelect
                                                size="md"
                                                width="100%"
                                                placeholder="Select Status"
                                                searchable={true}
                                                value={formData.attendanceStatus}
                                                options={attendanceStatus.filter((status) => status.Status === true || status.Status === 1)
                                                    .map((status) => ({
                                                        value: status.ShortName.trim(),
                                                        label: (status.AttendanceStatus).toUpperCase(),
                                                    }))}
                                                onChange={(value) =>
                                                    handleChange("attendanceStatus", value)
                                                }
                                            />
                                            {fieldError("attendanceStatus")}
                                        </div>
                                        <div className="se-field">
                                            <label>MOT Hours</label>
                                            <input
                                                className={`se-input ${inputClass("motHours")}`}
                                                type="text"
                                                placeholder="HH:MM"
                                                value={formData.motHours}
                                                onChange={(e) => {
                                                    let value = e.target.value
                                                        .replace(/[^0-9:]/g, "")
                                                        .slice(0, 5);
                                                    handleChange("motHours", value);
                                                }}
                                            />
                                            {fieldError("motHours")}
                                        </div>
                                    </div>
                                    <div className="se-field">
                                        <label>Reason</label>
                                        <textarea
                                            className={`se-input-reason ${inputClass("reason")}`}
                                            rows="4"
                                            placeholder="Enter Reason"
                                            value={formData.reason}
                                            onChange={(e) => handleChange("reason", e.target.value)}
                                        ></textarea>
                                        {fieldError("reason")}
                                    </div>
                                </div>
                                <div className="se-modal__footer">
                                    <button
                                        className="se-btn se-btn--ghost"
                                        onClick={handleCloseModal}
                                    >
                                        Cancel
                                    </button>
                                    <button className="se-btn se-btn--primary"
                                        onClick={() => {
                                            isEdit ? handleUpdate() : handleSave()
                                        }}>
                                        {isEdit ? "Update" : "Save"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {showDeleteModal && (
                        <div className="se-overlay">
                            <div className="se-modal">

                                <div className="se-modal__header">
                                    <h3>Delete Manual Entry</h3>
                                </div>

                                <div className="se-modal__body">
                                    <p>{deleteMessage}</p>
                                </div>
                                <div className="se-modal__footer">
                                    <button
                                        className="se-btn se-btn--ghost"
                                        onClick={() => {
                                            setShowDeleteModal(false);
                                            setSelectedManualCode(null);
                                        }}
                                    >
                                        No
                                    </button>
                                    <button
                                        className="se-btn se-btn--primary"
                                        onClick={handleConfirmDelete}
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );

}

export default ManualEntry;